import type Tender from '../entities/Tender';

export const getResponseDeadline = (tender: Tender): string => {
  return (
    tender.interaction?.userUpdatedResponseDeadline ??
    tender.responseDeadline ??
    '-'
  );
};
